import React from "react";

export default function QuittingSchool() {
  return (
    <div className="p-2.5 gap-2.5 bg-Onyx inline-flex flex-col items-center justify-start w-full pb-10">
      <div className="max-w-6xl">
        <p className="w-full font-Inter font-bold text-white inline text-[40px] leading-[normal]">
          Quitting School
        </p>
        <div className="w-[166px] h-[0] outline outline-1 outline-[rgba(242,242,242,1)]"></div>
        <p className="font-Inter text-sm font-extralight text-Grey inline leading-[normal]">
          Written on 16/06/22
        </p>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            Quitting school to start a startup tends to be glorified quite a
            fair bit - but the thing is, the harvard dropouts who start
            successful businesses tend to be already building a successful
            business. For example, when Mark Zuckerberg was working on facebook,
            the reason why he took a gap year to continue working on it was
            because there were too many users - he and his team were just saying
            to each other ‘Okay once we manage to get the load under control
            we’ll return to school and continue studying’. It turns out when
            Peter Thiel saw their traction, he didn’t believe that they would
            return to school which is why he decided to fund them anyway.
            <br />
            <br />
            (Take whatever I say with a pinch of salt, I roughly remember this
            story but I have the memory of a goldfish)
            <br />
            <br />
            However, the circumstances were quite different for me - I had a
            fully paid scholarship to spend 9 months in the US and 3 months in
            China, with opportunities to work in silicon valley and the China
            equivalent of SV. And unlike Mark Zuckerberg, I wasn’t running an
            immensely successful growth monster startup.
            <br />
            <br />
            At the time I quit school, we were running a completely different
            startup - one that aimed to help solve the problem of talking to
            users and getting insights. The funny thing about meta-startup
            ideas, that is, a startup that helps other startups, is that they
            tend to be started by inexperienced founders (like myself) who
            themselves are facing issues with the exact problem they are trying
            to solve (like not having users to talk to) and are often left
            wondering what went wrong.
            <br />
            <br />
            In our case, we were able to find a pretty large market oppurtunity
            - to this day, people are still contacting me from time to time
            requesting our services. And the business model made perfect sense
            too - Companies would pay us copious amounts of money to find users
            to talk to, and we would in turn pay copious amounts of money to
            users to convince them to be talked to. However, it was hard work
            finding users to talk to, we were going down to shopping malls,
            working the ground and directly asking people if they would like to
            participate in our research.
          </p>
        </div>
        <div className="w-full inline-flex flex-col items-center justify-center">
          <div className="bg-contain bg-no-repeat bg-center w-full h-[476px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4898/1442a6a44356c62b5e9201e769281a79075cf313.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline leading-[normal]">
            Getting rejected by a cat
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            The main issue we faced was that the end interviewees did not trust
            us at all - At times, when we were walking off after handing them
            the brochure, we would hear them whispering amongst themselves ‘$300
            for a 3 hour study? Must be a scam’.
            <br />
            <br />
            However, the main reason that things did not work out between us was
            that we as cofounders has different beliefs - which is okay, but for
            a startup to succeed the team is most important. If a team cannot
            rally together and execute under a unified vision, then a startup is
            bound to fail. And its surprisingly easy to see this problem in
            other startups, and also extremely painful to hear startups break-up
            due to this problem time and time again, even after years of working
            together.
            <br />
            <br />
            So if our startup was failing, why quit school? Well the thing is I
            really wanted to do a startup with my cofounder, Stephen, which is
            why I joined the team in the first place.
            <br />
            <br />
            Finding a co-founder is extremely difficult.&nbsp;
            <br />
            <br />
            Firstly, the person needs to be a complete idiot, considering how
            he/she is possibly sacrificing a $100k job to do something that will
            take probably 5 years of his/her life to have a 90% chance of
            failing and going completely bankrupt.
            <br />
            <br />
            Secondly, the person needs to be extremely capable and resourceful,
            and able to achieve whatever task you throw at them. If we need to
            talk to customers, you need to magically make 5 customers appear for
            interviews within the week. If we need to create a product demo, we
            need to have an MVP ready within a week. Note that there is no
            correlation between intelligence and how capable a person is - I’ve
            seen some incredibly smart people be extremely useless an
            ineffective. It doesn’t matter if your GPA is 5.0 and you know the
            entire YC doctrine about running startups, from talking to users to
            building product to having connections to investors, if you only
            manage to get talk to one user after one whole month.
            <br />
            <br />
            Thirdly, the person needs to be extremely hardworking. Working well
            past midnight and beyond if the job needs to be done, and without
            complaint (but this trait is surprisingly common in Singapore where
            I come from because nobody has any sense of work-life balance)
            <br />
            <br />
            So when Stephen told me he was still interested in starting a
            company with me, I decided whatever, school sucks anyway and I’m
            scared of going to China because I can barely speak Chinese.
          </p>
        </div>
        <div className="w-full p-2.5 gap-2.5 inline-flex flex-col items-center justify-start">
          <div className="bg-contain bg-center bg-no-repeat w-full h-[450px] bg-[url(https://uortjlczjmucmpaqqhqm.supabase.co/storage/v1/object/public/firejet-converted-images/4898/62e35f707571f2b7d9519cafe1df263fd9c16b4d.webp)]"></div>
          <p className="font-Inter text-sm font-extralight text-white inline drop-shadow-lg leading-[normal]">
            My Idiot Co-Founder
          </p>
        </div>
        <div className="py-6 w-full gap-2.5 inline-flex flex-row items-start justify-start">
          <p className="flex-1 font-Inter text-base text-Pearl inline leading-[1.8]">
            So, Stephen, if you’re reading this:
            <br />
            <br />
            Thanks for being my cofounder
            <br />
            We need to talk to 5 customers by next week
            <br />
            We are launching FireJet again in 2 weeks, so better fix all the UI
            bugs
          </p>
        </div>
      </div>
    </div>
  );
}
